import React from 'react';
import { Phone } from 'lucide-react';

/**
 * CallsConnectionPanel - Panel to connect iPhone calls or Twilio
 */
const CallsConnectionPanel = ({
  isConnected,
  connectionType,
  onConnect,
  onDisconnect,
  className = ''
}) => {
  if (isConnected) {
    return (
      <div className={`mx-3 mt-3 mb-0 flex items-center gap-2 px-3 py-2 bg-blue-500/10 border border-blue-500/30 rounded-lg ${className}`}>
        <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" />
        <span className="text-xs text-blue-400 font-medium">
          {connectionType === 'shortcuts' ? 'iPhone Calls Connected' : 'Twilio Voice Connected'}
        </span>
        <button
          onClick={onDisconnect}
          className="ml-auto text-gray-400 hover:text-white text-xs"
          data-testid="disconnect-calls-btn"
        >
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <div className={`m-3 mb-0 bg-gradient-to-r from-blue-900/50 to-purple-900/50 border border-blue-500/30 rounded-xl p-3 ${className}`}>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <div className="flex items-center gap-2 flex-1">
          <Phone className="text-blue-400" size={18} />
          <div>
            <h3 className="text-sm font-bold text-white">Connect Your Calls</h3>
            <p className="text-gray-300 text-xs">Sync iPhone call logs or connect Twilio for voice calls.</p>
          </div>
        </div>
        <div className="flex gap-2 w-full sm:w-auto">
          <button 
            onClick={onConnect}
            className="flex-1 sm:flex-initial bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-1.5 transition-all shadow-lg text-xs"
            data-testid="connect-iphone-calls-btn"
          >
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            iPhone
          </button>
          <button 
            onClick={onConnect}
            className="flex-1 sm:flex-initial bg-[#F22F46] hover:bg-[#d62a3e] text-white px-4 py-2 rounded-lg font-semibold flex items-center justify-center gap-1.5 transition-all shadow-lg text-xs"
            data-testid="connect-twilio-calls-btn"
          >
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0C5.381 0 0 5.381 0 12s5.381 12 12 12 12-5.381 12-12S18.619 0 12 0zm0 20.4c-4.639 0-8.4-3.761-8.4-8.4S7.361 3.6 12 3.6s8.4 3.761 8.4 8.4-3.761 8.4-8.4 8.4zm3.6-8.4c0 1.988-1.612 3.6-3.6 3.6s-3.6-1.612-3.6-3.6 1.612-3.6 3.6-3.6 3.6 1.612 3.6 3.6z"/>
            </svg>
            Twilio
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallsConnectionPanel;
